var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({class:{'remove-icon': !_vm.modern },attrs:{"icon":"","color":_vm.modern ? undefined : 'error'}},_vm.$listeners),[_c('v-icon',{attrs:{"size":"24"}},[_vm._v(" "+_vm._s(_vm.modern ? 'mdi-close' : 'mdi-close-circle')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }